import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import renderViewsState from '../../shared/render-views-state';

import Table from '../components/table/table';
import SortableOffer from '../components/table/order';
import Search from '../../shared/search/main';
import Filters from '../../shared/filters/main';

import { selectors as rootSelectors } from '../../root';

import PageContainer from '../../shared/page-container/main';
import CopyOfferPayout from '../components/forms/copy-offer-payouts/main';
import Regions from '../components/regions/main';
import tabs from '../tabs';

const isRocket = process.env.CPA_ENV === 'rocket';

const Main = renderViewsState((props) => {
	return (
		<PageContainer name='List of offers' tabs={tabs}>
			<div className="container__content programs-list">
				<Regions
					setRegions={props.setCountriesByRegion}
					regions={props.countriesByRegion}
				/>
				<div className="programs-list__filter-position clearfix">
					<Filters {...props} {...props.filters} />
				</div>
				<div className="ui-control-bar">
					<div className="ui-control-bar__item modify-item---search">
						<div className="ui-control-bar__item-position">
							<Search
								form="offersSearchForm"
								autoFocus={true}
								action={props.search}
								initialValues={props.searchInitialValues}
								{...props}
							/>
						</div>
					</div>
					<div className="ui-control-bar__item">
						<div className="ui-control-bar__item-position">
							{isRocket && (
								<button
									className="ui-btn ui-btn-primary"
									onClick={(e) => {
										e.stopPropagation();
										props.toggleSwitchToOrder();
									}}
								>
									{props.intl('Reorder')}
								</button>
							)}
							{isRocket && (
								<button
									className="ui-btn ui-btn-primary"
									onClick={(e) => {
										e.stopPropagation();
										props.sortByVolume();
									}}
								>
									{props.intl('By volume')}
								</button>
							)}
							{
								props.can('offers_list_export') &&
								<button className="ui-btn ui-btn-primary" onClick={props.exportAll}>
									{props.intl('Export')}
								</button>
							}
							{props.can('edit') && !isRocket && (
								<a
									className="ui-btn ui-btn-primary ui-btn-sign__plus"
									onClick={props.toggleCopyOfferPayout}
								>
									{props.intl('Transfer payouts')}
								</a>
							)}
							{props.can('edit') && (
								<Link to="programs/editor/" className="ui-btn ui-btn-primary ui-btn-sign__plus">
									{props.intl('Add offer')}
								</Link>
							)}
							<button className="ui-btn ui-btn-primary" onClick={props.apply.bind(null, props)}>
								{props.intl('Apply')}
							</button>
							<button className="ui-btn ui-btn-secondary ui-icon-clear" onClick={props.clear} />
						</div>
					</div>
				</div>
				{ props.switchToOrderMode ? <SortableOffer {...props} /> :  <Table {...props} /> }
			</div>
			<CopyOfferPayout {...props}/>
		</PageContainer>
	);
}, 'view');

export default connect(
	state => ({
		data: selectors.getData(state),
		countriesByRegion: selectors.getCountriesByRegion(state),
		table: selectors.getTable(state),
		orderOfferList: selectors.getOrderOfferList(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		error: selectors.getError(state),
		isCopyOfferPayoutPopupOpen: selectors.getIsCopyOfferPayoutPopupOpen(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		lists: state.root.lists,
		filters: selectors.getFilters(state),
		progressBar: selectors.getProgressBar(state),
		searchInitialValues: selectors.getSearchInitialValues(state),
		payoutCurrencies: selectors.getPayoutCurrencies(state),
		switchToOrderMode: selectors.getSwitchToOrderMode(state),
		shouldShowSaveOrderBtn: selectors.getShouldShowSaveOrderBtn(state),
		isSortedByVolume: selectors.getIsSortedByVolume(state),
		allOffersCollapsed: selectors.getAllOffersCollapsed(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/list/main.js